// extracted by mini-css-extract-plugin
export default {"wrapper":"CartSelect_wrapper__h5SRa","box":"CartSelect_box__GBT28","sm":"CartSelect_sm__n9dST","md":"CartSelect_md__rJosZ","lg":"CartSelect_lg__VE8Zj","xl":"CartSelect_xl__yy5r9"};